import Typography from "@/components/Typography/Typography";
import Dragger from "antd/es/upload/Dragger";
import { InboxOutlined } from "@ant-design/icons";
import { useState } from "react";
import { Form, Upload, UploadFile } from "antd";
import { toast } from "react-toastify";

export default function DocumentModalFileUploader() {
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  function checkBeforeUploadDocument(file: UploadFile) {
    const allowedTypes = [
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    const isAllowedType = file.type && allowedTypes.includes(file.type);

    if (!isAllowedType) {
      toast.error("Only PDF, Excel, and Word files are allowed!");
      return Upload.LIST_IGNORE;
    }

    const isLt5M = file.size! / 1024 / 1024 < 5;
    if (!isLt5M) {
      toast.error("File must be smaller than 5MB!");
      return Upload.LIST_IGNORE;
    }

    setFileList([file]);
    return false;
  }

  return (
    <Form.Item
      name="file"
      rules={[{ required: true, message: "Please select the file" }]}
    >
      <Dragger
        accept=".pdf,.xls,.xlsx"
        fileList={fileList}
        beforeUpload={checkBeforeUploadDocument}
        multiple={false}
        onRemove={() => {
          setFileList([]);
        }}
      >
        <Typography type="p" className="ant-upload-drag-icon">
          <InboxOutlined />
        </Typography>
        <Typography type="p" className="ant-upload-text">
          Click or drag file to this area to upload
        </Typography>
        <Typography type="p" className="ant-upload-hint">
          The maximum document size is no more than 5 MB (.pdf, .xlsx, .docx)
        </Typography>
      </Dragger>
    </Form.Item>
  );
}
